import { useMutation, useQuery, useQueryClient } from "react-query";
import { authApi } from "./auth.api";
import { initApiRequest } from "lib/api-request";

export interface LoginInterface {
  email: string;
  password: string;
}
export interface LoginResponseData {
  access: string;
  refresh: string;
  expiration: string;
  user: {
    id_uid: string;
    name: string;
    role: string;
    user_type: string;
  };
  role: string;
}

const {AdminLogin,GetOrganizationConfiguration,GetAdminPermissionList,ResetUserPassowrdDefault,DeleteTrainee} = authApi;
export const useGetOrginazation = (doaminName:string, enabled?: boolean) => {
  return useQuery({
    queryKey: [GetOrganizationConfiguration.actionName,doaminName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: GetOrganizationConfiguration,
        params:{domainName:doaminName}
      });
    },
    enabled,
    select(data) {
      return data?.data.data;
    },
  });
};

export const useGetAdminPermissionList = (enabled?: boolean) => {
  return useQuery({
    queryKey: [GetAdminPermissionList.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: GetAdminPermissionList,
      });
    },
    enabled,
    select(data) {
      return data?.data.data;
    },
  });
};









// export const useGetShiftById = (id: number, enabled?: boolean) => {
//   return useQuery({
//     queryKey: [GetShiftById.actionName],
//     queryFn() {
//       return initApiRequest<BackendSuccessResponse<any>>({
//         apiDetails: GetShiftById,
//         params: { id }
//       });
//     },
//     enabled,
//     select(data) {
//       return data?.data.Data;
//     },
//   });
// };
export const useResetPasswordToDefault = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ResetUserPassowrdDefault.actionName],
    mutationFn(requestData: any) {
      return initApiRequest<BackendSuccessResponse<unknown>>({
        apiDetails: ResetUserPassowrdDefault,
        pathVariables:{userID:requestData},
      });
    },
    onSuccess() {
    },
  });
};
export interface LoginInterface {
  email: string;
  password: string;
  user_type:number
}
export const useAdminLogin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [AdminLogin.actionName],
    mutationFn(requestData: LoginInterface) {
        return initApiRequest<BackendSuccessResponse<LoginResponseData>>({
        apiDetails: AdminLogin,
        requestData,
      })

    
    },
    onSuccess() {
    },
  });
};
export const useDeleteTrainee = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DeleteTrainee.actionName],
    mutationFn(requestData:any) {
      return initApiRequest<BackendSuccessResponse<unknown>>({
        apiDetails: DeleteTrainee,
        pathVariables: {traineeId : requestData },
      });
    },
    onSuccess() {
      // queryClient.invalidateQueries({ queryKey: [GetShiftList.actionName] });
    },
   
  });
};

